module.exports = __webpack_public_path__ + "img/gift.b132bb8c.svg";